import { create } from "zustand";

// Definisikan tipe data untuk user
interface User {
  id: number;
  username: string;
  full_name: string;
  role: string;
  outlet: number;
  master_outlets: { kode: number; outlet: string; alamat: string };
}

interface UserStore {
  user: User | null;
  setUser: (user: User) => void;
  clearUser: () => void;
}

// Buat store Zustand untuk user
const useUserStore = create<UserStore>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  clearUser: () => set({ user: null }),
}));

export default useUserStore;
